import {
  DollarOutlined,
  HomeOutlined,
  InfoOutlined,
  LogoutOutlined,
  PlusOutlined,
  QrcodeOutlined,
  SettingOutlined,
  ShoppingOutlined,
} from "@ant-design/icons";
import { Menu, Switch } from "antd";

import QRScanner from "./QRScanner";
import Radium from "radium";
import cabraCerroIcon from "../assets/cabraCerroIcon.svg";
import darkMode from "../assets/dark-mode.svg";
import logo from "../assets/opis-logo.svg";
import recoBoardsIcon from "../assets/recoBoardsIcon.ico";
import superBeeIcon from "../assets/superBeeIcon.ico";
import { useMoralis } from "react-moralis";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const SideMenu = ({ nftSection, challengesSection }) => {
  const [open, setOpen] = useState(false);
  const [dataQR, setDataQR] = useState("");
  const navigate = useNavigate();
  // Moralis logout
  const { logout } = useMoralis();

  //ScrollToShop
  const executeScrollToShop = () => {
    window.scrollTo({ top: nftSection.current.offsetTop, behavior: "smooth" });
  };
  //ScrollToChallenges
  const executeScrollToChallenges = () => {
    window.scroll({ top: challengesSection.current.offsetTop, behavior: "smooth" });
  };
  //getItem Function
  function getItem(label, key, icon, children, type) {
    return { key, icon, children, label, type };
  }

  const handleClick = (key) => {
    if (key === "/") navigate("/");
    else if (key === "/earn") executeScrollToChallenges();
    else if (key === "/shop") executeScrollToShop();
    else if (key === "/signout") logout();
    else if (key === "/scan-qr") setOpen(true);
    else if (key === "/mode") return;
    else navigate(key);
  };

  //ItemsCommunity
  const items = [
    getItem("Ganar OPIS", "/community/OPIS", <DollarOutlined />),
    getItem("Inicio", "/", <HomeOutlined />),
    getItem("Ganar", "/earn", <DollarOutlined />),
    getItem("Tienda NFT", "/shop", <ShoppingOutlined />),
    getItem("Escanear QR", "/scan-qr", <QrcodeOutlined />),
    getItem("COMUNIDADES", "/community", <PlusOutlined />, [
      getItem("CABRA DE CERRO", "/community/cabra-de-cerro", <img src={cabraCerroIcon} alt="" />),
      getItem("SUPERBEE", "/community/super-bee", <img src={superBeeIcon} alt="" />),
      getItem("RECO BOARDS", "/community/reco-boards", <img src={recoBoardsIcon} alt="" />),
    ]),
    getItem("Configuración", "/settings", <SettingOutlined />),
    getItem("Ayuda y preguntas", "/questions", <InfoOutlined />),
    getItem(
      <div style={styles.switchContainer}>
        <p style={styles.switchContainer.p}>Modo</p>
        <Switch onChange={() => console.log("")} size="small" />
      </div>,
      "/mode",
      <img src={darkMode} alt="dark mode" width={14} />
    ),
    getItem("Cerrar Sesión", "/signout", <LogoutOutlined />),
  ];

  return (
    <div style={styles.sideMenu}>
      <img
        src={logo}
        style={styles.sideMenu.opisImage}
        alt="opis"
        onClick={() => navigate("/")}
        title="Inicio"
      />
      <Menu
        onClick={({ key }) => handleClick(key)}
        items={items}
        defaultSelectedKeys={["/"]}
        defaultOpenKeys={["/community"]}
        mode="inline"
        style={styles.sideMenu.menu}
      ></Menu>

      <QRScanner onScanQR={open} setOnScanQR={setOpen} setData={setDataQR} />
    </div>
  );
};

export default Radium(SideMenu);

const query = {
  xs: "@media (max-width: 576px)",
  sm: "@media (max-width: 767px)",
  md: "@media (max-width: 992px)",
  lg: "@media (max-width: 1200px)",
  xl: "@media (max-width: 1600px)",
};

const styles = {
  sideMenu: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [query.sm]: { minWidth: "70vw" },
    opisImage: { margin: "16px 0", cursor: "pointer" },
    menu: { padding: "8px" },
  },
  switchContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    p: { margin: 0 },
  },
};
